"use client";

import React, { useEffect } from "react";

interface MousePosition {
  x: number | null;
  y: number | null;
}

const useMouse = (): MousePosition => {
  const [position, setPosition] = React.useState<MousePosition>({
    x: null,
    y: null,
  });

  useEffect(() => {
    const updatePosition = (ev: MouseEvent) => {
      setPosition({ x: ev.clientX, y: ev.clientY });
    };

    globalThis.addEventListener("mousemove", updatePosition);

    return () => {
      globalThis.removeEventListener("mousemove", updatePosition);
    };
  }, []);

  return position;
};

export { useMouse };
